import { User } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { NotificationSound } from "../../CommonComponents/CommonNotification";
import { ApiCall, DropDownData, getDateAndTime, handleDateChange, sanitizeInput } from "../../CommonComponents/CustomHooks";
import { AutoCompleteBoxNew, DateBox, FormButton, InputBox, SelectInputBox, Switch, TextareaBox } from "../../CommonComponents/InputBox";
import { setSubLoading } from "../../Redux/Services/AuthSlice";

const LeadEntry = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();

    const initialFormData = {
        "LeadEntryId": '',
        "leadNo": "",
        "leadManager": "",
        "contactName": "",
        "addressLine1": "",
        "prospectName": "",
        "addressLine2": "",
        "country": "",
        "state": "",
        "city": "",
        "pincode": "",
        "mobileNo": "",
        "emailID": "",
        "leadDate": getDateAndTime().date,
        "leadSource": "",
        "notQualifyRemarks": "",
        "noFurtherFollowUp": false,
        "nextFollowUpDate": "",
        "followUpRemark": "",
        "isAuto": false,
        "updateFollowUp": false,
        "followUpType": "",
        "enquiry": "",
        "jsonData": "",
        "nextFollowUpTime":''
    }
    const [formData, setFormData] = useState(initialFormData);
    const GetFollow = DropDownData('GetFollowUp')

    const GetLeadEntryData = async () => {
        const data = {
            Type: 'S',
            LeadNo: formData.leadNo,
        };
        let res = await ApiCall(`/api/LeadEntry/GetLeadEntry`, data);
        if (res.status === "SUCCESS") {
            setFormData(prev => ({
                ...prev,
                ...res.data
            }))
        }
        else if (res.status === "ERROR") {
            await (handleClear);
            await NotificationSound(res.status, res.message, res.focus,inputrefs)
        }

    };


    const getProspect = async (prospectName) => {
        let res = await ApiCall(`/api/AutoComplete/GetProspect`, { prospectName: prospectName, "title": 'Mr.'});
        if (res.status === "SUCCESS") {
            setFormData(prev => ({
                ...prev,
                ...res.data
            }))
        }
        else if (res.status === "ERROR") {
                setFormData(prev => ({
                    ...prev,
                    "LeadEntryId": '',
                    "leadNo": "",
                    "leadManager": "",
                    "contactName": "",
                    "addressLine1": "",
                    "prospectName": "",
                    "addressLine2": "",
                    "country": "",
                    "state": "",
                    "city": "",
                    "pincode": "",
                    "mobileNo": "",
                    "emailID": "",
                    "leadDate": "",
                    "leadSource": "",
                    "notQualifyRemarks": "",
                    "noFurtherFollowUp": false,
                    "nextFollowUpDate": "",
                    "followUpRemark": "",
                    "isAuto": false,
                    "updateFollowUp": false,
                    "followUpType": "",
                    "enquiry": ""
                }))
            await ( handleClear);
        }
       
    };


    const handleClear = () => {
        setFormData(initialFormData);
        inputrefs.current['txtLeadDate'].focus()  
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/LeadEntry/InsertLeadEntry`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    useEffect(() => {
        document.title = 'Lead Entry'
        inputrefs.current['txtLeadDate'].focus()
    }, [])

    const getStateAndCity = async (value) => {
        let reqData = {
            Pincode: value ? value : '',
        }
        let data = await ApiCall('/api/AutoComplete/GetCityStateCountry', reqData)
        if (data.status === 'SUCCESS') {
            setFormData(prev => ({
                ...prev,
                state: data?.state,
                city: data?.city,
                country: data?.country,
            }))
        } else {
            setFormData(prev => ({
                ...prev,
                state: '',
                city: '',
                country: '',
            }))
        }
    };

    useEffect(() => {
        if (!formData.isAuto) {
            setFormData(prev => ({
                ...prev,
                lead: ""
            }));
        }
    }, [formData.isAuto]);

    
    return (
        <>
            <div className='bg-white rounded-lg shadow-sm p-2'>
                <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                        <User className="w-5 h-5 text-blueled" />
                        <h2 className="text-xl font-semibold text-gray-800">Lead Entry</h2>
                    </div>
                </div>
                <div className='card-body pb-1'>
                    <div className="row">
                        <div className='col-md-12'>
                            <div className="row p-2">

                                <InputBox
                                    labelclass='form-label mb-0 d-flex'
                                    id="txtLeadNo"
                                    type="text"
                                    label="Lead"
                                    placeholder={formData.isAuto ? "Enter Lead No" : "System Generated"}
                                    maxLength='25'
                                    value={formData.leadNo}
                                    disabled={!formData.isAuto}
                                    required
                                    onChange={(e) => {
                                        setFormData({ ...formData, leadNo: e.target.value });
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && formData.leadNo?.trim() !== "") {
                                            GetLeadEntryData(formData.leadNo);
                                        }
                                    }}
                                    inputrefs={inputrefs}

                                    extraElement={
                                        <Switch
                                            divclassname="mb-3 w-30 h-3 ml-2"
                                            inputrefs={inputrefs}
                                            checked={formData.isAuto}
                                            label="Update"
                                            id='txtAuto'
                                            lableClassName='ms-1'
                                            extraclassname='form-switch'
                                            onChange={(e) => {
                                                const auto = e.target.checked;

                                                setFormData({
                                                    ...formData,
                                                    isAuto: auto,
                                                });
                                            }}
                                        />
                                    }
                                />

                                <DateBox
                                    inputrefs={inputrefs}
                                    label="Lead Date"
                                    placeholder="DD-MMM-YYYY"
                                    id='txtLeadDate'
                                    required
                                    //disabled={formData.leadDate}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtLeadManager'].focus()
                                        };
                                    }}
                                    selected={formData.leadDate === '' ? '' : new Date(formData.leadDate)}
                                    onChange={(e) => handleDateChange(e, setFormData, formData, 'leadDate')}
                                    minDate={new Date()}
                                />

                                <AutoCompleteBoxNew
                                    divclassname='col-md-3'
                                    id="txtLeadManager"
                                    placeholder="Enter Lead Manager"
                                    label='Lead Manager'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtProspectName"].focus(); };
                                    }}
                                    required={true}
                                    autocompleteType='GetLeadManager'
                                    value={formData.leadManager || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, leadManager: newInputValue })
                                        }
                                    }}
                                />
                                
                                <AutoCompleteBoxNew
                                    divclassname='col-md-3'
                                    id="txtProspectName"
                                    placeholder="Enter Prospect Name"
                                    label='Prospect Name'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current["txtContactName"].focus();
                                           
                                        };
                                    }}
                                    required={true}
                                    autocompleteType='GetProspect'
                                    value={formData.prospectName || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, prospectName: newInputValue })
                                            getProspect(newInputValue ? newInputValue:'')
                                        }
                                    }}
                                />

                                <InputBox
                                    id="txtContactName"
                                    type="text"
                                    label='Contact Name'
                                    required={true}
                                    placeholder="Enter Contact Name"
                                    maxLength='50'
                                    value={formData.contactName}
                                    onChange={(e) => setFormData({ ...formData, contactName: sanitizeInput(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtMobileNo'].focus() };
                                    }}
                                    divclassname="col-md-3"
                                />


                                <InputBox
                                    id="txtMobileNo"
                                    type="text"
                                    label='Mobile No'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtEmailID'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    placeholder='Enter Mobile No'
                                    maxLength='10'
                                    required={true}
                                    value={formData.mobileNo}
                                    onChange={(e) => setFormData({ ...formData, mobileNo: sanitizeInput(e.target.value) })}

                                />

                                <InputBox
                                    id="txtEmailID"
                                    type="text"
                                    label='Email ID'
                                    placeholder="Enter Email ID"
                                    maxLength='50'
                                    value={formData.emailID}
                                    onChange={(e) => setFormData({ ...formData, emailID: sanitizeInput(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtLeadSource'].focus() };
                                    }}
                                    divclassname="col-md-3"
                                    required={true}
                                />

                                <AutoCompleteBoxNew
                                    divclassname='col-md-3'
                                    id="txtLeadSource"
                                    placeholder="Enter Lead Source"
                                    label='Lead Source'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtAddressLine1"].focus(); };
                                    }}
                                    required={true}
                                    autocompleteType='GetLeadSourceName'
                                    value={formData.leadSource || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, leadSource: newInputValue })
                                        }
                                    }}
                                />


                                <InputBox
                                    id="txtAddressLine1"
                                    type="text"
                                    label='Address Line 1'
                                    placeholder="Enter Address Line 1"
                                    maxLength='50'
                                    value={formData.addressLine1}
                                    onChange={(e) => setFormData({ ...formData, addressLine1: sanitizeInput(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtAddressLine2'].focus() };
                                    }}
                                    divclassname="col-md-3 "
                                />
                                <InputBox
                                    id="txtAddressLine2"
                                    type="text"
                                    label='Address Line 2'
                                    placeholder="Enter Address Line 2"
                                    maxLength='50'
                                    value={formData.addressLine2}
                                    onChange={(e) => setFormData({ ...formData, addressLine2: sanitizeInput(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtPinCode'].focus() };
                                    }}
                                    divclassname="col-md-3 "
                                />

                              

                                <AutoCompleteBoxNew
                                    id="txtPinCode"
                                    placeholder="Enter Pincode"
                                    label='Pincode'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtCity"].focus(); };
                                    }}
                                    autocompleteType='GetPinCode'
                                    value={formData.pincode || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {

                                            setFormData({ ...formData, pincode: newInputValue,country:"", state: '', city: '' })
                                            getStateAndCity(newInputValue ? newInputValue : '')
                                        }
                                    }}

                                />

                                <AutoCompleteBoxNew
                                    divclassname='col-md-3'
                                    id="txtCity"
                                    placeholder="Enter City"
                                    label='City'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtState"].focus(); };
                                    }}
                                    autocompleteType='GetCity'
                                    value={formData.city || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, city: newInputValue })
                                        }
                                    }}
                                    contextKey={formData.country}
                                    contextKey2={formData.state}
                                />

                                <AutoCompleteBoxNew
                                    divclassname='col-md-3'
                                    id="txtState"
                                    placeholder="Enter State"
                                    label='State'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtCountry"].focus(); };
                                    }}
                                    autocompleteType='GetState'
                                    value={formData.state || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, state: newInputValue })
                                        }
                                    }}
                                    contextKey={formData.country}
                                />

                                <AutoCompleteBoxNew
                                    divclassname='col-md-3'
                                    id="txtCountry"
                                    placeholder="Enter Country"
                                    label='Country'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtFollowUpType'].focus(); };
                                    }}
                                    autocompleteType='GetCountry'
                                    value={formData.country || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, country: newInputValue })
                                        }
                                    }}
                                />

                            </div>
                        </div>
                    </div>


                </div>

                <div className="panel panel-primary mt-3 mb-3" style={{ border: "1px solid #cfe2ff" }}>

                    <div className="panel-heading flex py-1 px-2" style={{ fontSize: '15px', fontWeight: '600', backgroundColor: '#DBEAFD', }}>
                        Follow Up Details
                        <Switch
                            size='lg'
                            inputrefs={inputrefs}
                            label='Update FollowUp'
                            checked={formData.updateFollowUp}
                            id='txtUpdateFollowUp'
                            divclassname="col-md-3 ms-2"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtFollowUpType'].focus()
                                };
                            }}
                            onChange={(e) => setFormData({ ...formData, updateFollowUp: e.target.checked })}
                        />
                    </div>


                    <div className="mt-2 p-2 row">

                        <SelectInputBox
                            id="txtFollowUpType"
                            required
                            disabled={!formData.updateFollowUp}
                            value={formData.followUpType}
                            label='Follow Up Type'
                            onChange={(e) => setFormData({ ...formData, followUpType: e.target.value })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtNextFollowUpDate'].focus()
                                }
                            }}
                            divclassname="col-md-3"
                        >

                            <option value=''>--Please Select--</option>
                            {GetFollow?.data?.dropDownData?.map((item, index) =>
                                <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                            )}

                        </SelectInputBox>

                        <DateBox
                            inputrefs={inputrefs}
                            label="Next Follow Up Date"
                            required
                            placeholder="DD-MMM-YYYY"
                            id='txtNextFollowUpDate'
                            disabled={formData.nextFollowUpDate || !formData.updateFollowUp}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtNextFollowUpTime'].focus()
                                };
                            }}
                            selected={formData.nextFollowUpDate === '' ? '' : new Date(formData.nextFollowUpDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'nextFollowUpDate')}
                            minDate={new Date()}
                            divclassname="col-md-3"
                        />

                        <InputBox
                            id="txtNextFollowUpTime"
                            type="time"
                            label='Next Follow Up Time'
                            required={true}
                            maxLength='50'
                            value={formData.nextFollowUpTime}
                            onChange={(e) => setFormData({ ...formData, nextFollowUpTime: sanitizeInput(e.target.value) })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtFollowUpRemark'].focus() };
                            }}
                            divclassname="col-md-3"
                        />

                        <TextareaBox
                            id="txtFollowUpRemark"
                            placeholder="Enter Follow Up Remark"
                            autoComplete="off"
                            disabled={!formData.updateFollowUp}
                            maxLength='250'
                            label='Follow Up Remark'
                            value={formData.followUpRemark}
                            onChange={(e) => setFormData({ ...formData, followUpRemark: sanitizeInput(e.target.value) })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtRequirements'].focus()
                                }
                            }}
                            rows="1"
                            divclassname="col-md-3"
                        />

                        {/*<Switch*/}
                        {/*    size='lg'*/}
                        {/*    inputrefs={inputrefs}*/}
                        {/*    label='No further Follow Up'*/}
                        {/*    checked={formData.nofurtherFollowUp}*/}
                        {/*    id='txtNofurtherFollowUp'*/}
                        {/*    divclassname="col-md-3 mt-4"*/}
                        {/*    onKeyDown={(e) => {*/}
                        {/*        if (e.key === 'Enter') {*/}
                        {/*            inputrefs.current['txtRequirements'].focus()*/}
                        {/*        };*/}
                        {/*    }}*/}
                        {/*    onChange={(e) => setFormData({ ...formData, nofurtherFollowUp: e.target.checked })}*/}
                        {/*/>*/}



                    </div>
                </div>

                <div className="panel panel-primary mt-3 mb-3" style={{ border: "1px solid #cfe2ff" }}>

                    <div className="panel-heading flex py-1 px-2" style={{ fontSize: '15px', fontWeight: '600', backgroundColor: '#DBEAFD', }}>
                        Requirements
                    </div>


                    <div className="mt-2 p-2 row">

                        <TextareaBox
                            id="txtRequirements"
                            placeholder="Enter Requirements"
                            autoComplete="off"
                            maxLength='250'
                            label=''
                            value={formData.jsonData}
                            onChange={(e) => setFormData({ ...formData, jsonData: sanitizeInput(e.target.value) })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                   // inputrefs.current['btnSub'].focus()
                                }
                            }}
                            rows="6"
                            divclassname="col-md-12"
                        />

                       
                    </div>
                </div>
                {formData.isAuto && (
                <div className='row  mb-2 mt-2'>
                    <div className="panel panel-primary">
                        

                        <div className="panel-body pb-1 px-2" style={{ border: '1px solid #DBEAFD' }} >

                            <div className="panel panel-primary mt-2">
                                <div className="panel-heading py-1 px-2"
                                    style={{ fontSize: '13px', fontWeight: '600', backgroundColor: '#DBEAFD' }}>
                                    Total Records: {formData?.followUpDetail?.length || 0}
                                </div>

                                <div className="panel-body">
                                    {
                                        (!formData?.followUpDetail ||
                                            formData?.followUpDetail?.length === 0) ? (
                                            <div style={{
                                                padding: "25px 10px", textAlign: "center", background: "#EFF6FF", border: "1px dashed #D1D5DB", borderRadius: "8px", marginTop: "10px",
                                                marginBottom: "10px",
                                            }}
                                            >
                                                <i className="fa-solid fa-box-open" style={{
                                                    fontSize: "26px",
                                                    color: "#9CA3AF",
                                                    marginBottom: "8px"
                                                }}
                                                ></i>

                                                <div style={{ fontSize: "14px", fontWeight: "600", color: "#6B7280" }}>
                                                    No Records Found
                                                </div>

                                                <div style={{ fontSize: "12px", color: "#9CA3AF", marginTop: "3px" }}>
                                                    Try adjusting your filters or add new items.
                                                </div>
                                            </div>

                                        ) : (
                                            <div className="table-responsive"
                                                style={{ maxHeight: "267px", overflowY: "auto", position: 'relative' }}>

                                                <table className="table table-bordered table-striped">
                                                    <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                                                        <tr className="light-bg">

                                                                <th style={{ padding: "3px 3px", fontSize: '12px' }}>Follow Up Type</th>
                                                                <th style={{ padding: "3px 3px", fontSize: '12px' }}>Follow Up Date</th>
                                                                <th style={{ padding: "3px 3px", fontSize: '12px' }}>Next Follow Up Date</th>
                                                                <th style={{ padding: "3px 3px", fontSize: '12px' }}>Follow Up Remarks</th>
                                                                <th style={{ padding: "3px 3px", fontSize: '12px' }}>Further Follow Up</th>
                                                                <th style={{ padding: "3px 3px", fontSize: '12px' }}>Status</th>
                                                                <th style={{ padding: "3px 3px", fontSize: '12px' }}>Converted Date</th>
                                                                <th style={{ padding: "3px 3px", fontSize: '12px' }}>Reason</th>
                                                                <th style={{ padding: "3px 3px", fontSize: '12px' }}>Final Status Remarks</th>
                                                        </tr>
                                                    </thead>

                                                        <tbody>
                                                            {formData?.followUpDetail?.map((item, index) => (
                                                            <tr key={index} className="TableTrhover">

                                                                    <td style={{ padding: "3px" }}>{item.followUpType}</td>
                                                                    <td style={{ padding: "3px" }}>{item.followUpDate}</td>
                                                                    <td style={{ padding: "3px" }}>{item.nextFollowUpDate}</td>
                                                                    <td style={{ padding: "3px" }}>{item.followUpRemarks}</td>
                                                                    <td style={{ padding: "3px" }}>{item.furtherFollowup}</td>
                                                                    <td style={{ padding: "3px" }}>{item.status}</td>
                                                                    <td style={{ padding: "3px" }}>{item.convertedDate}</td>
                                                                    <td style={{ padding: "3px" }}>{item.reason}</td>
                                                                    <td style={{ padding: "3px" }}>{item.finalStatusRemarks}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                            </div>
                                        )}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                )}

                <div className='card-body mt-3'>
                    <FormButton
                        id={'btnSub'}
                        inputrefs={inputrefs}
                        handleSubmit={handleSubmit}
                        Export={false}
                        handleClear={handleClear}
                    />
                </div>
            </div>


        </>
    )
}
export default LeadEntry;